// src/container/Historia/Historia.jsx
const HITOS = [
  {
    year: "1930",
    title: "Fundación",
    text: "El 29 de septiembre nace en Ceuta el África Sport Club, germen del actual Unión África Ceutí.",
  },
  {
    year: "1939",
    title: "Fusión",
    text: "El África Sport Club absorbe al África Futbol Club, fundado en 1925.",
  },
  {
    year: "1941",
    title: "Cambio de nombre",
    text: "Por la ley que prohibía los nombres extranjeros en los clubes, pasa a llamarse África Club.",
  },
  {
    year: "1943",
    title: "Nace el Unión África Ceutí",
    text: "El club adopta su denominación actual: Unión África Ceutí Sociedad Deportiva. Ese mismo curso recibe la Copa Estadio del Consejo Superior de Deportes al club español con más actividad deportiva de la temporada 1943/44.",
  },
  {
    year: "1956/57",
    title: "El mejor curso en fútbol 11",
    text: "El club logra su mayor éxito histórico en fútbol 11 al clasificarse para el playoff de ascenso a Segunda División.",
  },
  {
    year: "1969/70 – 1979/80",
    title: "Copa del Generalísimo y Copa del Rey",
    text: "El primer equipo compite en la Copa del Generalísimo (1969/70) y años después en la Copa del Rey (1979/80).",
  },
  {
    year: "2005",
    title: "75 aniversario",
    text: "El club celebra sus bodas de platino, 75 años de historia deportiva en Ceuta.",
  },
  {
    year: "2006",
    title: "Medalla de honor de Ceuta",
    text: "La Ciudad Autónoma de Ceuta le concede la medalla de honor en reconocimiento a su trayectoria.",
  },
  {
    year: "2018/19",
    title: "Ascenso en fútbol sala",
    text: "El equipo de fútbol sala se proclama campeón de Segunda División B y logra el ascenso a Segunda División tras superar el playoff.",
  },
];

const PALMARES_BASE = [
  "Campeón de España Alevín: 1988/89, 1991/92 y 1992/93",
  "Campeón del grupo de División de Honor Juvenil: 2016/17",
];

const Historia = () => (
  <section className="bg-transparent">
    <div className="max-w-6xl mx-auto px-4 py-6 md:py-10">
      <header className="mb-8 text-center">
        <h1
          className="text-2xl md:text-3xl font-bold"
          style={{ color: "var(--ua-gold)" }}
        >
          Historia del Unión África Ceutí
        </h1>
        <p className="text-sm md:text-base text-slate-200 mt-2 max-w-2xl mx-auto">
          El club decano del fútbol ceutí, con casi un siglo de historia
          ligada al deporte de la ciudad.
        </p>
      </header>

      {/* Resumen */}
      <article className="bg-white/90 rounded-2xl shadow-md border border-slate-100 p-6 mb-8">
        <p className="text-sm md:text-base text-slate-700 leading-relaxed">
          La Unión África Ceutí Sociedad Deportiva es el club de fútbol más
          antiguo de la Federación de Fútbol de Ceuta, con sus orígenes en
          1930. A lo largo de su historia ha contado además con secciones de
          baloncesto, balonmano, ciclismo y tenis, aunque hoy su actividad se
          centra en el fútbol sala, disciplina en la que compite en las
          categorías nacionales del fútbol sala español.
        </p>
      </article>

      {/* Línea de tiempo */}
      <div className="relative border-l-2 border-white/20 pl-6 space-y-6 mb-10">
        {HITOS.map((hito) => (
          <div key={hito.year + hito.title} className="relative">
            <span
              className="absolute -left-[31px] top-1 w-3.5 h-3.5 rounded-full border-2 border-white"
              style={{ backgroundColor: "var(--ua-red)" }}
              aria-hidden="true"
            />
            <div className="bg-white/90 rounded-xl shadow-sm border border-slate-100 p-4">
              <span
                className="inline-block text-xs font-bold px-2 py-0.5 rounded-full mb-2"
                style={{
                  backgroundColor: "var(--ua-blue)",
                  color: "var(--ua-light)",
                }}
              >
                {hito.year}
              </span>
              <h3 className="font-semibold text-slate-900">{hito.title}</h3>
              <p className="text-sm text-slate-600 mt-1">{hito.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Palmarés de cantera */}
      <article className="bg-white/90 rounded-2xl shadow-md border border-slate-100 p-6">
        <h2 className="text-lg font-semibold text-slate-900 mb-3">
          Palmarés de cantera
        </h2>
        <ul className="list-disc list-inside space-y-1 text-sm text-slate-700">
          {PALMARES_BASE.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className="mt-4 text-[11px] text-slate-400">
          Fuente: Wikipedia y hemeroteca del club.
        </p>
      </article>
    </div>
  </section>
);

export default Historia;
